import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import type { SelectField } from '@twisto/api-graphql'
import { ContinueButton } from '@twisto/components/atoms/button'
import {
  SelectableListItem,
  SelectableListItemText,
} from '@twisto/components/molecules/selectable-list'
import { CheckmarkFilledIcon, ChevronRightIcon } from '@twisto/icons'

import * as styles from './select-field-list.styles'

type Props = {
  options: SelectField['options']
  value: SelectField['value']
  onSelectField: (value: string) => void
  disabled?: boolean
}

export const SelectFieldList = ({
  options,
  value: selectedValue,
  onSelectField,
  disabled = false,
}: Props) => {
  const handleOnClick = (value: string) => onSelectField(value)

  return (
    <>
      <div>
        {options?.map(({ label, value: optionsValue }) => {
          const isActiveItem = optionsValue === selectedValue

          return (
            <SelectableListItem
              key={optionsValue}
              endAdornment={
                isActiveItem ? (
                  <CheckmarkFilledIcon color="primary" size="24" />
                ) : (
                  <ChevronRightIcon color="gray" size="24" />
                )
              }
              state={
                disabled ? 'disabled' : isActiveItem ? 'active' : undefined
              }
              onSubmit={() => handleOnClick(optionsValue)}
            >
              <SelectableListItemText css={styles.selectFieldText}>
                {label}
              </SelectableListItemText>
            </SelectableListItem>
          )
        })}
      </div>
      {!isNil(selectedValue) && (
        <ContinueButton
          css={styles.continueButton}
          disabled={disabled}
          onClick={() => handleOnClick(selectedValue)}
        >
          <Trans id="flow.selectFieldList.formSubmit" />
        </ContinueButton>
      )}
    </>
  )
}
